module.exports = __webpack_public_path__ + "img/Remind.8feccab0.png";